function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  stroke: "#959595",
  strokeWidth: 2,
  d: "M23.42 44.5c11.875 0 21.5-9.626 21.5-21.5S35.295 1.5 23.42 1.5c-11.873 0-21.5 9.626-21.5 21.5s9.626 21.5 21.5 21.5z"
}), React.createElement("path", {
  fill: "#959595",
  d: "M30.729 26.791v-8.614c0-1.18-1.304-2.062-2.823-2.136h-8.97c-1.514.074-2.823.956-2.823 2.136v8.614c0 .562.602 1.017 1.344 1.017 0 0 1.275.171 1.344-1.049v-6.776l.005-.003c0-.177.952-.24.952.303v15.964c0 .6.668 1.075 1.458 1.04l.395.014s1.267 0 1.306-.998V28.35c-.006-.319.504-.304.504-.304s.51-.015.504.304v7.9c.044 1.064 1.306 1.051 1.306 1.051l.395-.015c.79.036 1.458-.44 1.458-1.039V20.283c0-.543.952-.48.952-.303l.005.003v6.776c.074 1.045 1.344 1.05 1.344 1.05.742 0 1.344-.456 1.344-1.018M26.78 12.058a3.36 3.36 0 1 0-6.721 0 3.36 3.36 0 0 0 6.72 0"
}));

var SvgMaleUnselected = function SvgMaleUnselected(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMaleUnselected, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/male-unselected.3dd24985.svg";
export { ForwardRef as ReactComponent };